import { render, staticRenderFns } from "./addwechat.vue?vue&type=template&id=89021cf2&scoped=true"
import script from "./addwechat.vue?vue&type=script&lang=js"
export * from "./addwechat.vue?vue&type=script&lang=js"
import style0 from "./addwechat.vue?vue&type=style&index=0&id=89021cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89021cf2",
  null
  
)

export default component.exports